import { render } from "./Fission.vue?vue&type=template&id=032f32d2&scoped=true"
import script from "./Fission.vue?vue&type=script&lang=js"
export * from "./Fission.vue?vue&type=script&lang=js"

import "./Fission.vue?vue&type=style&index=0&id=032f32d2&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032f32d2"]])

export default __exports__